import React from "react";
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Box } from "@mui/material";
import { AlignHorizontalCenter } from "@mui/icons-material";
import { formatCurrency } from "../helpers/formatter";
import { pathOr } from "ramda";
import moment from "moment/moment";
import { shareCrmLink } from "../redux/actions/policyAction";
import { useDispatch } from "react-redux";

const RevivalOption = (props) => {
    const { policy } = props
    const user = pathOr(false, ['user'], props)
    const dispatch = useDispatch();
    const shareLink = () => {
        dispatch(shareCrmLink({policyNumber: policy.policyNumber}))
    }
    const calculateInterest = (principal, rate, startDate, endDate) => {
        // Convert dates to JavaScript Date objects
        const start = new Date(startDate);
        const end = new Date(endDate);
        console.log("eD", endDate.format("DD-MM-YYYY"))
        if (isNaN(start) || isNaN(end) || start > end) {
            throw new Error("Invalid start or end date");
        }
        // Calculate the difference in days
        const diffInTime = end - start; // Difference in milliseconds
        const diffInDays = diffInTime / (1000 * 60 * 60 * 24); // Convert to days
        // Calculate interest
        const interest = principal * (rate / 100) * (diffInDays / 365);
        return {
            principal,
            rate,
            startDate,
            endDate,
            diffInDays: Math.round(diffInDays), // Rounded to nearest day
            interest: interest.toFixed(2), // Rounded to 2 decimal places
        };
    };
    const paying = () => {
        const rate = pathOr(0,['loanInfo','loanInterest'],policy)
        const calc = calculateInterest(policy.pendingPremium, rate, moment(), moment(policy.commencementDate).add(policy.term,'years'))
        return {
            total: Math.round(parseFloat(calc.principal) + parseFloat(calc.interest)),
            principal:  parseFloat(calc.principal),
            interest: Math.round(parseFloat(calc.interest))
        }
    }
    const notPaying = () => {
        const node = []
        let remainYear = 0
        let prevInterest = 0
        let totalPremium = policy.pendingPremium
        let totalInterest = pathOr(0,['loanInfo','odInterest'],policy)
        for (let i = policy.term - pathOr(0,['loanInfo','remainingTerm'],policy) + 1; i <= policy.term; i++) {
            remainYear++
            //let interest = policy.premium * (pathOr(0,['loanInfo','loanInterest'],policy)/100) + prevInterest
            const rate = pathOr(0, ['loanInfo', 'loanInterest'], policy)
            
            totalPremium = totalPremium + policy.premium
            //const interest = calculateInterest(totalPremium, rate, moment(), moment(policy.commencementDate).add(i,'years')).interest
            const interest = (totalPremium * rate)/100;

            prevInterest = interest
            totalInterest = Math.round(parseFloat(totalInterest) + parseFloat(interest))
            node.push(
                <>
                    <Grid item size={4} sx={{ borderLeft: 1, textAlign: 'center' }}>
                        <Typography variant="caption">{i}</Typography>
                    </Grid>
                    <Grid item size={4} sx={{ borderLeft: 1, textAlign: 'center' }}>
                        <Typography variant="caption">₹ {formatCurrency(policy.premium)}</Typography>
                    </Grid>
                    <Grid item size={4} sx={{ borderLeft: 1, borderRight: 1, textAlign: 'center' }}>
                        <Grid>
                            {/* <Grid item size={12}><Typography variant="caption">₹{ parseFloat(totalInterest)}+ ₹ {formatCurrency(Math.round(interest))}</Typography></Grid> */}
                            <Grid item size={12}><Typography variant="caption">₹ {formatCurrency(Math.round(interest))}</Typography></Grid>
                        </Grid>
                    </Grid>
                </>
            )
        }

        return {node, totalInterest, totalPremium, total: totalPremium+totalInterest }
    }
    return (
        <div style={{ borderRadius: 16, borderWidth: 1, borderColor: '#489135', background: '#EDF6EB', marginTop: 12, borderStyle: 'solid', }}>
            <Grid container columns={{ xs: 4, sm: 8, md: 12 }} spacing={2} style={{ borderWidth: 1, borderColor: '#489135', padding: 30 }}>
                <Grid size={5} spacing={2}>
                    <div>
                        <div style={{ borderLeftWidth: 2, borderBottomWidth: 1, borderLeftStyle: 'solid', borderBottomStyle: 'solid', padding: 4, backgroundColor: '#DCECD8', transform: 'skew(-20deg)', }}>
                            <Typography>Revival Option </Typography>
                        </div>
                        <Typography variant='caption'>Pay only interest and revive your policy.</Typography>
                    </div>
                </Grid>
                <Grid spacing={2}>
                    <div>
                        <Typography color='#40812F' variant='h5' align='center'>₹ {formatCurrency(policy.surrenderValue)}</Typography>
                        <Typography align='center' variant='body2'>Paid up Value </Typography>
                    </div>
                </Grid>
                {user && (
                    <Grid>
                        <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                            <Button variant='contained' color='success'>Avail Now</Button>
                        </div>
                    </Grid>
                )}
                {!user && (
                    <Grid>
                        <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                            <Button variant='contained' color='success' onClick={() => shareLink()}>Share Link</Button>
                        </div>
                    </Grid>
                )}
            </Grid>
            <Grid container columns={{ xs: 4, sm: 6, md: 12 }} style={{ borderWidth: 1, borderColor: '#489135', backgroundColor: 'white', padding:'12px'}}>
                <Grid item size={12} mb={2}>
                    <Typography>{"Revive Option 1: Customer paying future premium"}</Typography>
                </Grid>
                <Grid item size={6} style={{ background: '#F5F5F5' }}>
                    <Grid container>
                        <Grid item size={8}>
                            <Typography variant="caption">{"Interest Rate"}</Typography>
                        </Grid>
                        <Grid item size={4}>
                            <Typography variant="caption">{pathOr(0, ['loanInfo', 'interest'], policy)}%</Typography>
                        </Grid>
                        <Grid item size={8}>
                            <Typography variant="caption">{"Pending premium"}</Typography>
                        </Grid>
                        <Grid item size={4}>
                            <Typography variant="caption">₹  {formatCurrency(paying().principal)}</Typography>
                        </Grid>
                        <Grid item size={8}>
                            <Typography variant="caption">{"Interest amt/year"}</Typography>
                        </Grid>
                        <Grid item size={4}>
                            <Typography variant="caption">₹  {formatCurrency(Math.round((policy.pendingPremium* pathOr(0,['loanInfo','loanInterest'],policy)/100)))}</Typography>
                        </Grid>
                        <Grid item size={8}>
                            <Typography variant="caption">{"Total Interest amt"}</Typography>
                        </Grid>
                        <Grid item size={4}>
                            <Typography variant="caption">₹  {formatCurrency(paying().interest)}</Typography>
                        </Grid>
                        <Grid item size={8}>
                            <Typography variant="caption">{"Loan amt + interest"}</Typography>
                        </Grid>
                        <Grid item size={4}>
                            <Typography variant="caption">₹ {formatCurrency(paying().total)}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item size={6} style={{ background: '#387129',alignContent:'center' }}>
                    <Grid container>
                        <Grid item size={12}>
                            <Typography color="#FAAD14" align="center">₹ {formatCurrency(policy.approxMaturityAmt)}</Typography>
                        </Grid>
                        <Grid item size={12}>
                            <Typography variant="subtitle2" color="#ffff" align="center" sx={{ fontSize: 10 }}>{"Approx. Maturity Amount"}</Typography>
                        </Grid>
                        <Grid item size={12}>
                            <Typography color="#FAAD14" align="center">₹ {formatCurrency(policy.approxMaturityAmt - (pathOr(0, ['loanInfo', 'odPayable'], policy) + pathOr(0, ['pendingPremium'], policy)))}</Typography>
                        </Grid>
                        <Grid item size={12}>
                            <Typography variant="subtitle2" color="#ffff" align="center" sx={{ fontSize: 10 }}>{"Net Amount after Loan-deducted "}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container columns={{ xs: 4, sm: 6, md: 12 }} style={{ borderWidth: 1, borderColor: '#489135', backgroundColor: 'white', padding:'12px',borderRadius:16}}>
                <Grid item size={12} mb={2}>
                    <Typography>{"Revive Option 2 : Customer not paying future premium"}</Typography>
                </Grid>
                <Grid item size={6} style={{ background: '#F5F5F5' }}>
                    <Grid container>
                        <Grid item size={4} sx={{ borderLeft: 1, borderTop: 1, borderBottom: 1, textAlign: 'center' }}>
                            <Typography variant="caption">{"Year"}</Typography>
                        </Grid>
                        <Grid item size={4} sx={{ borderLeft: 1, borderTop: 1, borderBottom: 1, textAlign: 'center' }}>
                            <Typography variant="caption">{"Premium"}</Typography>
                        </Grid>
                        <Grid item size={4} sx={{ borderLeft: 1, borderTop: 1, borderBottom: 1, borderRight: 1, textAlign: 'center' }}>
                            <Typography variant="caption">{"Interest Amt"}</Typography>
                        </Grid>
                        <Grid item size={4} sx={{ borderLeft: 1, textAlign: 'center' }}>
                            <Typography variant="caption">{"Current"}</Typography>
                        </Grid>
                        <Grid item size={4} sx={{ borderLeft: 1, textAlign: 'center' }}>
                            <Typography variant="caption">₹ {formatCurrency(pathOr(0, ['pendingPremium'], policy))}</Typography>
                        </Grid>
                        <Grid item size={4} sx={{ borderLeft: 1, borderRight: 1, textAlign: 'center' }}>
                            <Typography variant="caption">₹ {formatCurrency(pathOr(0, ['loanInfo', 'odPayable'], policy))}</Typography>
                        </Grid>
                        {notPaying().node}
                        <Grid item size={4} sx={{ borderLeft: 1, borderBottom: 1, textAlign: 'center', background: '#DCECD8' }}>
                            <Typography variant="caption">{"Total"}</Typography>
                        </Grid>
                        <Grid item size={4} sx={{ borderLeft: 1, borderBottom: 1, textAlign: 'center', background: '#DCECD8' }}>
                            <Typography variant="caption">₹{formatCurrency(notPaying().totalPremium)}</Typography>
                        </Grid>
                        <Grid item size={4} sx={{ borderLeft: 1, borderBottom: 1, borderRight: 1, textAlign: 'center', background: '#DCECD8' }}>
                            <Typography variant="caption">₹{formatCurrency(notPaying().totalInterest)}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item size={6} alignContent={'center'} style={{ background: '#387129',alignContent:'center' }}>
                    <Grid container>
                        <Grid item size={12}>
                            <Typography color="#FAAD14" align="center">₹ {formatCurrency(policy.approxMaturityAmt)}</Typography>
                        </Grid>
                        <Grid item size={12}>
                            <Typography variant="subtitle2" color="#ffff" align="center" sx={{ fontSize: 10 }}>{"Approx. Maturity Amount"}</Typography>
                        </Grid>
                        <Grid item size={12}>
                            <Typography color="#FAAD14" align="center">₹ {formatCurrency(policy.approxMaturityAmt - notPaying().total)}</Typography>
                        </Grid>
                        <Grid item size={12}>
                            <Typography variant="subtitle2" color="#ffff" align="center" sx={{ fontSize: 10 }}>{"Net Amount after Loan-deducted "}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

export default RevivalOption